export enum LanguageEnum {
    DE = 'German',
    IT = 'Italian',
    EN = 'English'
}
